import React, { useState } from 'react';
import parse from 'html-react-parser';
import { post } from '../httpClient';

const INPUT_TYPE = {
    text: 'text',
    email: 'email',
    phone: 'tel',
};

export default function InquiryFormRenderer({ comp }) {
    const [values, setValues] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState({});

    const fields = comp.fields || [];

    const handleChange = (name, value) => {
        setValues(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: false }));
    };

    const validate = () => {
        const errs = {};
        fields.forEach(field => {
            if (!field.required) return;
            if (field.type === 'checkbox') {
                if (!values[field.name]) errs[field.name] = true;
            } else {
                if (!values[field.name]?.toString().trim()) errs[field.name] = true;
            }
        });
        return errs;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errs = validate();
        if (Object.keys(errs).length > 0) {
            setErrors(errs);
            return;
        }
        setSubmitting(true);
        try {
            await post('forms/send', {
                formData: values,
                transportId: comp.transportId || null,
            });
            setSubmitted(true);
        } catch {
            // error already shown by httpClient toast
        } finally {
            setSubmitting(false);
        }
    };

    if (submitted) {
        return (
            <div className="inq-success">
                {comp.successMessage ? parse(comp.successMessage) : 'Your message has been sent.'}
            </div>
        );
    }

    return (
        <div className="inq-wrapper">
            {comp.title && <div className="inq-title">{parse(comp.title)}</div>}
            {comp.description && <div className="inq-desc">{parse(comp.description)}</div>}

            <form className="inq-form" onSubmit={handleSubmit} noValidate>
                {fields.map((field, idx) => (
                    <div key={idx} className={`inq-field${errors[field.name] ? ' inq-field--error' : ''}`}>
                        {field.type === 'checkbox' ? (
                            <label className="inq-checkbox-label">
                                <input
                                    type="checkbox"
                                    className="inq-checkbox"
                                    checked={!!values[field.name]}
                                    onChange={e => handleChange(field.name, e.target.checked)}
                                />
                                <span>
                                    {parse(field.label || field.name)}
                                    {field.required && <span className="inq-required"> *</span>}
                                </span>
                            </label>
                        ) : (
                            <>
                                <label className="inq-label">
                                    {parse(field.label || field.name)}
                                    {field.required && <span className="inq-required"> *</span>}
                                </label>
                                {field.type === 'textarea' ? (
                                    <textarea
                                        className="inq-control"
                                        placeholder={field.placeholder}
                                        rows={4}
                                        value={values[field.name] || ''}
                                        onChange={e => handleChange(field.name, e.target.value)}
                                    />
                                ) : field.type === 'select' ? (
                                    <select
                                        className="inq-control"
                                        value={values[field.name] || ''}
                                        onChange={e => handleChange(field.name, e.target.value)}
                                    >
                                        <option value="">{field.placeholder || '—'}</option>
                                        {(field.options || []).map((opt, oIdx) => (
                                            <option key={oIdx} value={opt}>{opt}</option>
                                        ))}
                                    </select>
                                ) : (
                                    <input
                                        type={INPUT_TYPE[field.type] || 'text'}
                                        className="inq-control"
                                        placeholder={field.placeholder}
                                        value={values[field.name] || ''}
                                        onChange={e => handleChange(field.name, e.target.value)}
                                    />
                                )}
                            </>
                        )}
                        {errors[field.name] && (
                            <span className="inq-error">
                                {field.errorMessage || 'This field is required'}
                            </span>
                        )}
                    </div>
                ))}

                <button type="submit" className="inq-submit" disabled={submitting}>
                    {submitting ? '…' : (comp.submitLabel || 'Send')}
                </button>
            </form>
        </div>
    );
}
